import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e4a6c9a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("video", {
    ref: "videoRef",
    type: "video/mp4",
    muted: "",
    class: "video-no-controls",
    loop: "",
    poster: _ctx.imagePoster
  }, [
    _createVNode("source", {
      src: _ctx.videoSrc,
      type: "video/mp4"
    }, null, 8, ["src"])
  ], 8, ["poster"]))
})